export default "__VITE_ASSET__z8FQx8nP__"